import { useState } from "react";
import '../css/cseDeptStyle.css';

const CtrPage = () => {

    const [activeTab, setActiveTab] = useState("v-pills-Awards");
    const [peopleTab, setPeopleTab] = useState("Faculty");

    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        console.log(tabId)
    }

    const handlePeopleTabClick = (tabId) => {
        setPeopleTab(tabId);
        console.log(tabId)
    }
    return (
        <><div class="dept-wrapper">
            <div class="container">
                <section class="py-4 header">
                    <header>
                        <img src="https://nitw.ac.in/api/static/files/10_2024-12-18-11-22-58.jpg" class="img-fluid" />
                    </header>
                    <div class="row">
                        <div class="col-md-3">
                            {/* Tabs nav */}
                            <div class="nav flex-column nav-pills nav-pills-custom" id="v-pills-tab" role="tablist"
                                aria-orientation="vertical">
                                {/*<a class="nav-link    active" id="v-pills-home-tab" data-toggle="pill" href="#v-pills-home" role="tab" aria-controls="v-pills-home" aria-selected="true"><span>Home</span></a>*/}
                                <a class={`nav-link ${activeTab === 'v-pills-Awards' ? 'active' : ''}`} id="v-pills-Awards-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-Awards')}
                                    role="tab" aria-controls="v-pills-Awards"
                                    aria-selected={activeTab === 'v-pills-Awards' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-Awards' ? '#c20315' : '#00FFFF' }}> <span>About</span> </a>

                                <a class={`nav-link ${activeTab === 'v-pills-Faculty' ? 'active' : ''}`} id="v-pills-Faculty-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-Faculty')}
                                    role="tab" aria-controls="v-pills-Faculty" aria-selected={activeTab === 'v-pills-Faculty' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-Faculty' ? '#c20315' : '#00FFFF' }}>
                                    <span>People </span>
                                </a>

                                <a class={`nav-link ${activeTab === 'v-pills-visionandmission' ? 'active' : ''}`} id="v-pills-visionandmission-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-visionandmission')}
                                    role="tab" aria-controls="v-pills-visionandmission"
                                    aria-selected={activeTab === 'v-pills-visionandmission' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-visionandmission' ? '#c20315' : '#00FFFF' }}>
                                    <span>Procedure for ToT</span>
                                </a>



                                <a class={`nav-link ${activeTab === 'v-pills-labs' ? 'active' : ''}`} id="v-pills-requisitionforms-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-requisitionforms')}
                                    role="tab" aria-controls="v-pills-requisitionforms"
                                    aria-selected={activeTab === 'v-pills-requisitionforms' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-requisitionforms' ? '#c20315' : '#00FFFF' }}>
                                    <span>Requisition Forms</span>
                                </a>

                                <a class={`nav-link ${activeTab === 'v-pills-NotableAlumni' ? 'active' : ''}`} id="v-pills-NotableAlumni-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-NotableAlumni')}
                                    role="tab" aria-controls="v-pills-NotableAlumni"
                                    aria-selected={activeTab === 'v-pills-NotableAlumni' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-NotableAlumni' ? '#c20315' : '#00FFFF' }}>
                                    <span>Technologies Ready</span>
                                </a>


                                <a class={`nav-link ${activeTab === 'v-pills-AcademicResearchGroup' ? 'active' : ''}`} id="v-pills-AcademicResearchGroup-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-AcademicResearchGroup')}
                                    role="tab"
                                    aria-controls="v-pills-AcademicResearchGroup" aria-selected={activeTab === 'v-pills-AcademicResearchGroup' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-AcademicResearchGroup' ? '#c20315' : '#00FFFF' }}> <span>Insdustry Connect</span>
                                </a>


                                <a class={`nav-link ${activeTab === 'v-pills-Students' ? 'active' : ''}`}
                                    id="v-pills-Students-tab" data-toggle="pill" onClick={() => handleTabClick('v-pills-Students')} role="tab"
                                    aria-controls="v-pills-Students" aria-selected={activeTab === 'v-pills-Students' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-Students' ? '#c20315' : '#00FFFF' }}>
                                    <span>R&D Club </span>
                                </a>

                                <a class={`nav-link ${activeTab === 'v-pills-E-Books' ? 'active' : ''}`} id="v-pills-labs-E-Books" data-toggle="pill" onClick={() => handleTabClick('v-pills-E-Books')} role="tab"
                                    aria-controls="v-pills-E-Books"
                                    aria-selected={activeTab === 'v-pills-E-Books' ? 'true' : 'false'}
                                    style={{ backgroundColor: activeTab === 'v-pills-E-Books' ? '#c20315' : '#00FFFF' }}>

                                    <span>Contact</span>
                                </a>




                            </div>
                            <div class="head_of_dept">
                                <a href="https://erp.nitw.ac.in/ext/profile/ph-haranath"
                                    target="_blank"> <img src="https://erp.nitw.ac.in/ext/profile/getUserImage/ph-haranath" alt="" class="img-fluid" width="190" height="220" />
                                    <h6>  Prof. Haranath Divi</h6>
                                </a>
                                <p class="justified-text">Head, CTR <br />
                                    <a href="mailto:ctr_head@nitw.ac.in "
                                        style={{ color: "#808080" }}>ctr_head@nitw.ac.in </a><br />+91-870-245 2781/2554
                                </p>
                            </div>
                        </div>



                        <div class="col-md-9">
                            {/* Tabs content */}
                            <div class="tab-content" id="v-pills-tabContent">
                                {/*<div class="tab-pane ${activeTab === 'v-pills-' ? 'active' : ''} fade    show active p-2" id="v-pills-home" role="tabpanel" aria-labelledby="v-pills-home-tab"></div>*/}

                                <div class={`tab-pane fade ${activeTab === 'v-pills-visionandmission' ? 'show active' : 'alumniTabHide'}  p-2`} id="v-pills-visionandmission"
                                    role="tabpanel" aria-labelledby="v-pills-visionandmission-tab">
                                        <h3>Who should apply?</h3>
                                        <p>Interested individuals/entrepreneurs having adequate Scientific & Engineering knowledge, good financial background, experience of product manufacturing/fabrication with technical capability in the area of interested technology/know-how, having or zeal to set–up facilities for production would be encouraged.</p>
                                        <h3>How to apply?</h3>
                                        <p>Send your duly filled and signed “Application Form for Technology Transfer” along with a Demand Draft/Bankers cheque of Rs. 500/- (for Indian Entrepreneurs) or US $100/- (for foreign entrepreneurs) as a non-refundable application processing fee drawn in favor of “Director, NIT Warangal” and payable at Warangal to the following address:</p>
                                        <p><b>Note:</b> Applications without processing fee as applicable above of Rs. 500/- or US $100/- for each technology will not be considered.</p>
                                </div>

                                <div class={`tab-pane fade ${activeTab === 'v-pills-requisitionforms' ? 'show active' : 'alumniTabHide'}  p-2`} id="v-pills-requisitionforms"
                                    role="tabpanel" aria-labelledby="v-pills-requisitionforms-tab">
                                     <ul>
                                        <li><a href="https://nitw.ac.in/api/static/files/User_Requisition_Form_for_Anechoic_chamber_2024-9-26-16-21-36.pdf" target="_blank"><i class="fa fa-check-circle-o" aria-hidden="true"></i>Application Form for Seeking Technology Transfer</a></li>
                                       </ul>
                                </div>



                                <div class={`tab-pane ${activeTab === 'v-pills-academics' ? 'show active' : 'alumniTabHide'} fade    p-2" id="v-pills-academics`} role="tabpanel"
                                    aria-labelledby="v-pills-academics-tab">

                                    <div class="row">

                                        <div class="col-md-10 col-sm-12">
                                            <div class="card-4">
                                                <div class="card-detail">
                                                    <div class="head-bx">
                                                        {/* <h3 class="" align='center'> Notices/Announcements </h3> */}
                                                        <p style={{ textAlign: 'justify' }}>

                                                            {/* <a href="https://nitw.ac.in/api/static/files/Advisory_on_recent_covid_-19_variant_2023-12-20-14-46-52.pdf">
                                                                - Institute Health Centre: Advisory on recent covid -19 variant  </a> <br></br> */}

                                                        </p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>




                                <div class={`tab-pane ${activeTab === 'v-pills-labs' ? 'show active' : 'alumniTabHide'} fade  `} id="v-pills-labs" role="tabpanel"
                                    aria-labelledby="v-pills-labs-tab">
                                    <div class="row laboratory-facilities">
                                        <div class="col-md-12 col-sm-6 laboratory-facilities-individual">
                                            <header>
                                                <h3 class="" align='center'>Remote Access Service</h3>
                                            </header>

                                            <p class="justified-text">Central Library, NITW introduced a new service called "Remote Access Services - MyLOFT (My Library On Fingertips)" for the benefit of Research Scholars and Faculty. MyLOFT is a mobile App. Through MyLOFT research scholars and faculty can access e-resources subscribed by the NITW anywhere and anytime. Hence, all the P.G. students, Ph.D. students and faculty are requested to utilize the facility to enhance the quality Engineering Education and Research.
                                                <br></br>
                                                <br></br>
                                                <b> Remote Access Services Request Form: </b>
                                                <a href="https://forms.gle/3UxbXJ3q9MEqY3PCA">
                                                    https://forms.gle/3UxbXJ3q9MEqY3PCA </a></p>


                                        </div>

                                    </div>
                                </div>


                                <div class={`tab-pane ${activeTab === 'v-pills-Phd' ? 'show active' : 'alumniTabHide'} fade   p-2`} id="v-pills-Phd" role="tabpanel"
                                    aria-labelledby="v-pills-Phd-tab">
                                    <h4 class=" mb-4">Phd</h4> <a href="" target="_blank"> <span class="highlight">P</span>h.D.
                                        Students List ( Full / Part Time) <i class="fa fa-link " aria-hidden="true"></i> </a>
                                </div>



                                <div class={`tab-pane ${activeTab === 'v-pills-Faculty' ? 'show active' : 'alumniTabHide'} fade  `} id="v-pills-Faculty" role="tabpanel"
                                    aria-labelledby="v-pills-Faculty-tab">
                                    <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">


                                        <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'Faculty' ? 'active' : ''} `} id="nav-faculty-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-faculty"
                                            style={{ backgroundColor: peopleTab === 'Faculty' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("Faculty") }}>Head</a>


                                        {/* <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'AdjunctFaculty' ? 'active' : ''} `}
                                            id="nav-AdjunctFaculty-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-AdjunctFaculty" aria-selected="false" onClick={() => { handlePeopleTabClick("AdjunctFaculty") }}> Adjunct Faculty</a> */}


                                        <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'NonTeachingStaff' ? 'active' : ''} `}
                                            id="nav-NonTeachingStaff-tab" data-toggle="tab"
                                            role="tab" aria-controls="nav-NonTeachingStaff"
                                            style={{ backgroundColor: peopleTab === 'NonTeachingStaff' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("NonTeachingStaff") }}>Faculty</a>


                                        <a class={`nav-item subtabs tab-bold nav-link ${peopleTab === 'ResearchScholars' ? 'active' : ''} `} id="nav-ResearchScholars-tab"
                                            data-toggle="tab" role="tab"
                                            aria-controls="nav-ResearchScholars"
                                            style={{ backgroundColor: peopleTab === 'ResearchScholars' ? '#c20315' : '#00FFFF' }} onClick={() => { handlePeopleTabClick("ResearchScholars") }}>
                                            Staff</a>


                                    </div>

                                    <div class="tab-content py-3 px-3 px-sm-0" id="nav-tabContent"
                                        style={{ marginTop: "5%", marginLeft: "1%" }}>
                                        <div class={`tab-pane ${peopleTab === 'Faculty' ? 'show active' : ''} fade`} id="nav-faculty" role="tabpanel"
                                            aria-labelledby="nav-faculty-tab">
                                            {/*<h4 class=" mb-4">Faculty</h4>*/}
                                            {/* <a href="" target="_blank"><span class="highlight">F</span>aculty Profiles <i class="fa fa-external-link" aria-hidden="true"></i></a>*/}
                                            <section id="profile-info">

                                                <div class="col-md-12 profile-info-individual">
                                                    <div class="row">
                                                        <div class="col-md-3"> <a
                                                            href="https://erp.nitw.ac.in/ext/profile/ph-haranath"
                                                            target="_blank"> <img src="https://erp.nitw.ac.in/ext/profile/getUserImage/ph-haranath" alt=""
                                                                class="img-fluid" /> </a> </div>
                                                        <div class="col-md-9">
                                                            <div class="card ">
                                                                <div class="data">
                                                                    <h5> <a href="https://erp.nitw.ac.in/ext/profile/ph-haranath"
                                                                        target="_blank">Prof. Haranath Divii P</a> </h5>
                                                                    <span>Head, CTR</span>
                                                                    <p class="contact-info">
                                                                        {/* <i class="fa fa-phone"
                                                                            aria-hidden="true"></i> -<br /> */}
                                                                        <i class="fa fa-mobile fa-lg"
                                                                            aria-hidden="true"></i> +91-870-245 2781/2554  <br /> <i
                                                                                class="fa fa-envelope" aria-hidden="true"></i> <a
                                                                                    href="mailto:ctr_head@nitw.ac.in ">ctr_head@nitw.ac.in </a> </p>
                                                                    {/* <p class="justified-text">Modeling, Simulation and Optimization; Process Simulation using Aspen; Reaction Engineering; Thermodynamics; Energy management and CO2 Capture.</p> */}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </section>

                                        </div>


                                        <div class={`tab-pane ${peopleTab === 'NonTeachingStaff' ? 'show active' : ''} fade`} id="nav-NonTeachingStaff" role="tabpanel"
                                            aria-labelledby="nav-NonTeachingStaff-tab">
                                            <div class="row academic_group">

                                                {/* <div class="col-md-6">
                                                    <div class="card">
                                                        <div class="d-flex align-items-center">
                                                            <div class="image"> <img src="https://nitw.ac.in/api/static/files/6_2024-12-18-11-21-56.jpg" alt=""
                                                                class="img-fluid" /> </div>
                                                            <div class="ml-3 w-100">
                                                                <h6 class="mb-0 mt-0">Smt. GSR Sanjeevini</h6><span>Technical Officer</span>
                                                                <div class=" mt-2">
                                                                    <p class="contact-info"> <i class="fa fa-mobile fa-lg"
                                                                        aria-hidden="true"></i> +91 870 2464276<br /> <i
                                                                            class="fa fa-envelope" aria-hidden="true"></i> <a
                                                                                href="mailto:gsrs@nitw.ac.in">gsrs@nitw.ac.in</a>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                        <div class={`tab-pane ${peopleTab === 'ResearchScholars' ? 'show active' : ''} fade`} id="nav-ResearchScholars" role="tabpanel"
                                            aria-labelledby="nav-ResearchScholars-tab">

                                            <div class="row phd-std-row">
                                                {/* <div class="col-md-6">
                                                    <div class="card">
                                                        <div class="d-flex align-items-center">
                                                            <div class="image"> <img src="https://nitw.ac.in/api/static/files/7_2024-12-18-11-22-11.jpg" alt=""
                                                                class="img-fluid" /> </div>
                                                            <div class="ml-3 w-100">
                                                                <h6 class="mb-0 mt-0"> Shri. Kasubojula Sharath </h6><span> Technical Assistant </span>
                                                                <div class=" mt-2">
                                                                    <p class="contact-info"> <i
                                                                        class="fa fa-envelope" aria-hidden="true"></i> <a
                                                                            href="mailto:kasubojulas@nitw.ac.in">kasubojulas@nitw.ac.in</a>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}


                                                {/* <div class="col-md-6">
                                                    <div class="card">
                                                        <div class="d-flex align-items-center">
                                                            <div class="image"> <img src="https://nitw.ac.in/api/static/files/9_2024-12-18-11-22-42.jpg" alt=""
                                                                class="img-fluid" /> </div>
                                                            <div class="ml-3 w-100">
                                                                <h6 class="mb-0 mt-0"> Shri. Bhagadhi Koteshwer Rao </h6><span> Office Attendant </span>
                                                                <div class=" mt-2">
                                                                    <p class="contact-info"> <i
                                                                        class="fa fa-envelope" aria-hidden="true"></i> <a
                                                                            href="mailto:koteshwerrao1973@nitw.ac.in">koteshwerrao1973@nitw.ac.in </a>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>







                                {/*<div class="tab-pane ${activeTab === 'v-pills-' ? 'active' : ''} fade   " id="v-pills-NonTeachingStaff" role="tabpanel" aria-labelledby="v-pills-NonTeachingStaff-tab"><h4 class=" mb-4">Non-Teaching Staff</h4><table class="table table-sm "><thead><tr><th>Sl. No</th><th>Name of the Staff Member</th><th>Designation</th><th>Division</th></tr></thead><tbody><tr><td>1</td><td>Smt. K.S.S.S. Padmasri</td><td>Senior Technical Assistant</td></tr><tr><td>2</td><td>Smt. Shalini Avala</td><td>Technical Assistant</td></tr><tr><td>3</td><td>Sri . R Shivamallikarjun</td><td>Technical Assistant</td><td>CSE</td></tr><tr><td>4</td><td> Sri R. Jeevan kumar</td><td>Senior Technician</td></tr><tr><td>5</td><td>Sri. D. Ramesh</td><td>Senior Technician</td></tr><tr><td>6</td><td>Sri. B. Ramesh</td><td>Junior Assistant</td></tr><tr><td>7</td><td>K. Venkatamma</td><td> Technician (upgd)</td></tr><tr><td>8</td><td> K. Jayaraj</td><td>Caretaker SG-II</td></tr><tr><td>9</td><td>B. Sunil kumar</td><td>Electrician (Daily wage)</td></tr><tr><td>10</td><td>T. Varsha Sree</td><td>Skilled</td></tr><tr><td>11</td><td> M. Padma Rao</td><td>Skilled</td></tr><tr><td>12</td><td>P. Suma </td><td>Skilled</td></tr><tr><td>13</td><td>M. Mahendar</td><td>Un-Skilled</td></tr><tr><td>14</td><td>K. Srinivasulu</td><td>Un-Skilled</td><td>CSE</td></tr><tr><td>15</td><td>T. Sampath </td><td> Un-Skilled</td></tr></tbody></table></div>*/}
                                <div class={`tab-pane ${activeTab === 'v-pills-Students' ? 'show active' : 'alumniTabHide'} fade  `} id="v-pills-Students" role="tabpanel"
                                    aria-labelledby="v-pills-Students-tab">
                                    <div class="row std-society">
                                        <div class={`tab-pane ${activeTab === 'v-pills-Students' ? 'show active' : 'alumniTabHide'} fade  `} id="v-pills-Students" role="tabpanel"
                                            aria-labelledby="v-pills-Students-tab">
                                            <div class="row std-society">



                                            </div>
                                        </div>
                                    </div>
                                </div>










                                <div class={`tab-panel ${activeTab === 'v-pills-FIS' ? 'show active' : 'alumniTabHide'} fade `} id="v-pills-FIS" role="tabpanel"
                                    aria-labelledby="v-pills-FIS-tab">
                                    <div class="row FIS">

                                        {/* <h4 align='center'>Faculty Information System</h4><br></br><br></br> */}
                                        <p class="justified-text">
                                            The Central Library has implemented a new “Faculty Information System” under the Indian Research Information Network System (IRINS) to showcase the academic and research activities of the institute faculty members and provide an opportunity to create a scholarly research network.</p>
                                        <br></br>
                                        <p class="justified-text">
                                            The NITW- Indian Research Information Network System (IRINS) will support the integration of the existing research management system such as HR system, course management, grant management system, institutional repository, Open and commercial citation databases, scholarly publishers, etc. This will be integrated with the academic identities such as ORCID ID, Scopus ID, Research ID, Microsoft Academic ID, and Google Scholar ID for ingesting the scholarly publication from various sources. This Faculty Information System can become the source for the NIRF, NAC and other international raking systems. The Faculty Information System can be accessed by everyone through the following link:
                                        </p>

                                        <p class="justified-text"><b>Website: </b><a href="https://nitw.irins.org/">https://nitw.irins.org/</a></p>



                                    </div>
                                </div>




                                <div class={`tab-panel ${activeTab === 'v-pills-E-Books' ? 'show active' : 'alumniTabHide'} fade `} id="v-pills-E-Books" role="tabpanel"
                                    aria-labelledby="v-pills-E-Books-tab">
                                    <div class="row E-Books">



                                        <div className="postal_details col-md-6">

                                            <p>
                                                Head, Center for Translational Research (CTR)<br />
                                                Room No. CII-102, Innovation and Incubation Building<br />
                                                National Institute of Technology Warangal<br />
                                                Hanumakonda, 506004, Telangana, INDIA.<br />
                                                Email: ctr_head@nitw.ac.in<br />
                                                Tel: +91-870-245 2781/2554<br />
                                                Fax: +91-870-245 9547


                                            </p>
                                        </div>




                                    </div>



                                </div>
                                <div class={`tab-panel ${activeTab === 'v-pills-AYL' ? 'show active' : 'alumniTabHide'} fade `} id="v-pills-AYL" role="tabpanel"
                                    aria-labelledby="v-pills-AYL-tab">
                                    <div class="row AYL">
                                        <p class="justified-text">
                                            <img src="https://nitw.ac.in/api/static/files/Ask_a_Libraria_2022-7-22-10-26-13.png" alt="profile-image" class="profile" /><br></br>
                                            Due to the Covid-19 pandemic, the Central library of NIT Warangal was close down for the public. However, we do not want the students and faculty suffer from getting any information or help from the library. Hence, the central library has created an online, real time ‘virtual reference service’ facility in the library webpage. ‘Ask a Librarian’ is a free online web-based service through email.

                                        </p>
                                    </div>
                                </div>

                                <div class={`tab-pane ${activeTab === 'v-pills-AcademicResearchGroup' ? 'show active' : ''} fade `} id="v-pills-AcademicResearchGroup" role="tabpanel"
                                    aria-labelledby="v-pills-AcademicResearchGroup-tab">
                                    <div class="row academic_group">





                                    </div>


                                </div>



                                <div class={`tab-pane ${peopleTab === 'AdjunctFaculty' ? 'show active' : ''} fade`} id="nav-AdjunctFaculty" role="tabpanel"
                                    aria-labelledby="nav-AdjunctFaculty-tab">


                                </div>

                                <div class={`tab-panel ${activeTab === 'v-pills-NotableAlumni' ? 'show active' : 'alumniTabHide'} fade `} id="v-pills-NotableAlumni" role="tabpanel"
                                    aria-labelledby="v-pills-NotableAlumni-tab">

                                    {/* <h3>Web OPAC </h3> */}
                                    <div class="row notable-alumni">



                                    </div>
                                </div>



                                <div class={`tab-pane ${activeTab === 'v-pills-Awards' ? 'show active' : ''} fade  `} id="v-pills-Awards" role="tabpanel"
                                    aria-labelledby="v-pills-Awards-tab">
                                    <p>The Center for Translational Research (CTR) at the National Institute of Technology Warangal (NITW) serves as a pivotal hub for fostering innovation and facilitating the transfer of cutting-edge technologies to industry and society. Operating under the aegis of NIT Warangal, the CTR is dedicated to bridging the gap between academic research and practical applications by promoting the development and commercialization of indigenous technologies. The center supports entrepreneurs, industries, and legal entities in accessing NITW’s technical know-how through structured technology transfer processes, as outlined in the Application Form for Seeking Technology Transfer, ensuring seamless collaboration and adherence to statutory regulations</p>
                                    <div className="row vision-mission-section">
                                        <div className="col-md-6 vision-section">
                                            <h4 className="mt-2 mb-2"><img src="CSEDeptAssets/images/vision.png" className="img-fluid mr-3"
                                                alt="" /> Vision</h4>
                                            <p className="justified-text">The mission of the Center for Translational Research (CTR) is to catalyze the transformation of innovative research into tangible, market-ready solutions that address societal and industrial needs. By providing a robust framework for technology transfer, as evidenced by the detailed application process and requirements for entrepreneurs (both Indian and foreign), the CTR aims to empower industries and individuals with NITW’s advanced technological expertise. The center is committed to fostering sustainable partnerships, ensuring transparency, and upholding the highest standards of competence and integrity in all its interactions, as emphasized by the mandatory declarations and processing fees in the technology transfer application.</p>
                                        </div>
                                        <div className="col-md-6 mission-section">
                                            <h4 className="mt-2 mb-2"><img src="CSEDeptAssets/images/mission.png" className="img-fluid mr-3"
                                                alt="" /> Mission</h4>
                                            <p className="justified-text">The vision of the Center for Translational Research (CTR) is to establish NIT Warangal as a global leader in translational research and technology transfer, driving innovation that shapes the future of industry and society. By facilitating access to NITW’s pioneering technologies through a meticulous and inclusive application process, the CTR aspires to create a vibrant ecosystem where academic excellence meets entrepreneurial ambition. The center envisions a world where its structured mechanisms, such as the requirement for detailed documentation and statutory clearances, enable seamless technology adoption, fostering economic growth and technological advancement on a national and international scale.</p>

                                        </div>
                                    </div>
                                </div>

                                <div class={"tab-pane ${activeTab === 'v-pills-ResearchScholars' ? 'active' : ''} fade  "} id="v-pills-ResearchScholars" role="tabpanel"
                                    aria-labelledby="v-pills-ResearchScholars-tab">

                                </div>

                                <div class={`tab-pane ${activeTab === 'v-pills-PhotoGallery' ? 'show active' : ''} fade  `} id="v-pills-PhotoGallery" role="tabpanel"
                                    aria-labelledby="v-pills-PhotoGallery-tab">

                                    <div class="details">




                                        {/* <h5>General Rules</h5> */}
                                        <p class="justified-text">
                                            -Library is a place for study and research. Strict silence is to be observed.
                                            <br></br>
                                            -A user has to show identity card whenever he / she enters the Library.
                                            <br></br>
                                            -All the personal belongings should be deposited at the counter.
                                            <br></br>
                                            -The user has to pay Rs. 10/- towards loss of token of personal belongings counter.
                                            <br></br>
                                            -Users are requested to allow frisking of person at the Library exit gate while leaving the Library.
                                            <br></br>
                                            -Personal books, printed material, photocopy material are not allowed inside the Library.
                                            <br></br>
                                            -Outsiders are not allowed into the Library.
                                            <br></br>
                                            -Smoking is strictly prohibited.

                                        </p>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        </>
    );
}

export default CtrPage;
